import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'brt-map',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, ButtonModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.css'
})
export class MapComponent {
  Leaflet: any;
  @Input() lat = 51.505;
  @Input() lng = -0.09;
  @Input() zoom = 13;
  @Output() locationSelected = new EventEmitter<{ lat: number, lng: number, address?: string, postcode?: string }>();

  searchQuery = '';

  ngAfterViewInit(): void {
    import('leaflet').then(module => {
      this.Leaflet = module.default || module;
      setTimeout(() => this.initMap());
    });
  }

  @ViewChild('map') mapElement: ElementRef<HTMLElement>;
  private map: any;
  private marker: any;

  private initMap(): void {
    this.map = this.Leaflet.map(this.mapElement.nativeElement, {
      center: [this.lat, this.lng],
      zoom: this.zoom
    });

    this.Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);

    this.setMarker(this.lat, this.lng);

    setTimeout(() => this.map.invalidateSize(), 0);

    this.map.on('click', (e: any) => {
      this.setMarker(e.latlng.lat, e.latlng.lng);
      this.locationSelected.emit({ lat: e.latlng.lat, lng: e.latlng.lng });
    });
  }

  private setMarker(lat: number, lng: number) {
    if (!this.map) return;
    if (this.marker) this.map.removeLayer(this.marker);
    this.marker = this.Leaflet.marker([lat, lng]).addTo(this.map);
    this.map.setView([lat, lng], this.map.getZoom());
  }

  async searchOnMap() {
    if (!this.searchQuery?.trim()) return;
    const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&q=${encodeURIComponent(this.searchQuery)}`;
    const result = await fetch(url, { headers: { Accept: 'application/json' } }).then(r => r.json());
    const item = result?.[0];
    if (!item) return;

    const lat = parseFloat(item.lat);
    const lng = parseFloat(item.lon);
    this.setMarker(lat, lng);
    this.locationSelected.emit({ lat, lng, address: item.display_name, postcode: item.address?.postcode });
  }
}
